import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@material-ui/icons/School";
import WorkIcon from "@material-ui/icons/Work";
import witIcon from "../assets/icons/WIT_Icon.png";
import ropesAndGrayIcon from "../assets/icons/ropesAndGray_Icon.svg";
import mghIcon from "../assets/icons/MGH_Icon.png";
import athenaIcon from "../assets/icons/Athena_Icon.png";
import gtLogo from "../assets/icons/GTLogo.png";
import "../styles/Experience.css";

function Experience() {
  return (
    <div className="experience !text-[black] dark:!text-[white] dark:!bg-[#3d4851]">
      <VerticalTimeline lineColor="#DC4441">
      <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2024 - Present"
          iconStyle={{ background: "#EABE92", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            athenahealth
          </h3>
          <img src={athenaIcon} className="w-52" alt="athenahealth"/>
          <p className="!font-bold !mt-1">Senior Software Engineer</p>
          <p className="!mt-0">
            - Joined the team reinventing athenahealth&apos;s clinical inbox with an AI chatbot, faster search, and streamlined work completion for providers; became the team&apos;s lead contributor and helped move releases from every 2–3 weeks to weekly<br/>
            - Integrated AI capabilities into athenaOne, an EHR used by 170K+ clinicians, and built search on OpenSearch to help providers find and act on work faster<br/>
            - Visited 5 provider organizations in 5 weeks across 4 states, gathering feedback from physicians in person and shipping a new release at every visit, turning their feedback into working features within about an hour (<a href="https://www.linkedin.com/posts/athenahealth_what-a-special-24-hours-with-four-dynamo-activity-7510790487952400385-MB2q" target="_blank" rel="noreferrer" className="underline">featured by athenahealth</a>)<br/>
            - Co-led inbox design with our UX designer and demoed new features to leadership multiple times; wrote my own tickets and worked out how to source the clinical data providers needed<br/>
            - Built a provider Out-of-Office feature, now generally available, letting clinicians mark themselves out and assign coverage; on a 4-person team, authored the entire Java Spring Boot backend microservice and much of the React front end<br/>
            - Completed the most tickets among my cohort on the Clinicals team for multiple years, across front-end (React) and back-end (Perl, Java) work
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2025 - Present"
          iconStyle={{ background: "#DC4441", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Georgia Institute of Technology
          </h3>
          <img src={gtLogo} className="w-32" alt="Georgia Tech"/>
          <h4 className="vertical-timeline-element-subtitle">
            Master of Science in Computer Science (In Progress)
          </h4>

          <p className="!font-bold">Artificial Intelligence</p>
          <p className="!mt-0">
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2021 - 2024"
          iconStyle={{ background: "#EABE92", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Massachusetts General Hospital
          </h3>
          <img src={mghIcon} className="w-20" alt="MGH"/>
          <p className="!font-bold">Software Engineer</p>
          <p className="!mt-0">
            - Full stack software development on large scale applications used by Doctors, Nurses, and Hospital Administrators<br/>
            - Developed web applications through .NET Framework with C# and JavaScript<br/>
            - Improved a web application&apos;s performance by over 60% by introducing parallelization and restructuring its architecture<br/>
            - Contributed to a machine learning model that predicts patient hospital discharge with 80% accuracy
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work" 
          date="2020 - 2021"
          iconStyle={{ background: "#EABE92", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Wentworth Institute of Technology
          </h3>
          <img src={witIcon} className="w-20" alt="Wentworth"/>
          <p className="!font-bold">Research Assistant</p>
          <p className="!mt-0">
            - Consistently planned scrum meetings with 2 other contributors<br/>
            - Collaborated with a fellow student to create a PDF Reader android application with improved accessibility<br/>
            - Published a peer-reviewed paper, <a href="https://www.frontiersin.org/journals/computer-science/articles/10.3389/fcomp.2021.628832/full" target="_blank" rel="noreferrer" className="underline">Readability Enhancement for PDF Documents</a>, in Frontiers in Computer Science, with nearly 8,000 views and 1,600+ downloads
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2020 - 2020"
          iconStyle={{ background: "#EABE92", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Ropes and Gray
          </h3>
          <img src={ropesAndGrayIcon} className="w-40" alt="Ropes and Gray"/>
          <p className="!font-bold">Desktop Services Specialist</p>
          <p className="!mt-0">
          - Assembled and configured desktops and laptops to meet specific specifications and requirements<br/>
          - Proficiently diagnosed and resolved a wide range of computer network, software, and hardware issues<br/>
          - Developed Python automation routines to significantly enhance operational efficiency
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education "
          date="2017 - 2021"
          iconStyle={{ background: "#DC4441", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Wentworth Institute of Technology
          </h3>
          <img src={witIcon} className="w-20" alt="Wentworth"/>
          <h4 className="vertical-timeline-element-subtitle">
            Bachelor of Science Degree
          </h4>

          <p className="!font-bold">Computer Science</p>
          <p className="!mt-0">
            - Minor in Computer Networking and Applied Math<br/>
            - Notable Courses: Software Engineering, Web Programming, Machine Learning, Algorithms, Data Structures, Mobile Application Development<br/>
            - 3.84/4.00 overall GPA (Magna Cum Laude)
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}

export default Experience;
